<template>
  <div class="health-navigator">
    <Component :is="component" />
  </div>
</template>

<script lang="ts" setup>
  import { useHealthStore } from '~/store/health';
  import HealthSection from '~/pages/HealthSection.vue';
  import SingleArticle from '~/components/SingleArticle/SingleArticle.vue';
  import PageTemplate from '~/components/PageTemplate/PageTemplate.vue';
  import { usePageStore } from '~/store/pagesData';
  import { useArticleAnalyticsHead } from '~/domains/head/analytics/services/useArticleAnalyticsHead';
  import { useSeoHead } from '~/domains/head/seo/services/useSeoHead';
  import { useLastModifiedHead } from '~/domains/head/technical/services/useLastModifiedHead';

  definePageMeta({ layout: 'health' });

  const healthStore = useHealthStore();
  const pageStore = usePageStore();

  if (healthStore.isHealthArticle || healthStore.isHealthPage) {
    useSeoHead(
      computed(() => pageStore.currentSeo!),
      {
        ampLink: Boolean(pageStore.currentArticle?.ampEnabled),
      },
    );
    useArticleAnalyticsHead(pageStore.currentArticle, pageStore.currentSeo);
    useLastModifiedHead(pageStore.currentArticle?.lastModified);
  }

  const component = computed(() =>
    healthStore.isHealthArticle
      ? SingleArticle
      : healthStore.isHealthPage
        ? PageTemplate
        : HealthSection,
  );
</script>

<style lang="scss">
  .health-navigator {
    height: 100%;
  }

  .single-article {
    /* здесь находятся базовые стили, который используеются у ВСЕХ шаблонов страниц.
  Сами шаблоны находятся в components/singleArticle/ArticleTemplates
  */
    &__the-footer {
      margin: 0 16px;
      @include tablet {
        margin: 0;
      }
    }

    &__content-container {
      max-width: 100vw;
      padding: 0 16px;
      @include tablet {
        padding: 0 24px;
      }
    }

    .article-note {
      margin-bottom: 16px;
      padding: 0 16px;

      @include tablet {
        padding: 0;
      }

      @include big-tablet {
        padding: 0 24px;
      }
    }
  }
  .article__actions {
    margin: 0 16px;
    padding-bottom: 16px;

    @include tablet {
      margin: 0;
    }

    @include big-tablet {
      margin: 0 24px;
    }
  }

  .article-note {
    margin-top: 24px;
    &_empty {
      display: none;

      @include desktop {
        display: block;
      }
    }
  }
</style>
